<template>    
    <div>
        <default-drawer />
        <universe-list />
    </div>
</template>
<script> 
    import DefaultDrawer from '@/layouts/default/Drawer'    
    import UniverseList from '@/layouts/Universe/List'        
    export default {
        name: 'Dashboard',
        components: {
            DefaultDrawer,
            UniverseList,
        },
        data: () => {
            return {
            }
        },        
        computed: {
        },
        watch: {
        },        
    }
</script>
<style scoped>
</style>
